<template>
  <div class="work-flow-history-activity">
    <h1>{{ $t('teamTaskDetail.workFlowHistoryActivity') }}</h1>
    <div class="mt-3">
      <Timeline :key="timeLineKey" :items="timeLineData" />
    </div>
  </div>
</template>

<script>
import UserHistoryDataProvider from '../../../services/userHistory'
import { userHistoryMixins } from '../../../utils/mixins'
import Timeline from '../Timeline'
export default {
  name: 'work-flow-history-activity',
  mixins: [userHistoryMixins],
  components: {
    Timeline,
  },
  data() {
    return {
      timeLineKey: 1,
    }
  },
  props: {
    needUpdate: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getWorkflowHistory(data) {
      UserHistoryDataProvider.getUserHistory(data)
        .then(res => {
          this.setWorkFlowHistoryData(res.data.data.message.historyDto)
        })
        .catch(err => {
          
        })
    },
  },
  computed: {
    timeLineData() {
      return this.workFlowHistoryData
    },
  },
  watch: {
    needUpdate(val) {
      if (val === true) {
        this.getWorkflowHistory({ IssueKey: this.$route.params.id })
        setTimeout(() => {
          this.timeLineKey += 1
        }, 200)
      }
    },
  },
  beforeMount() {
    this.getWorkflowHistory({ IssueKey: this.$route.params.id })
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/globalCss.scss';

.work-flow-history-activity {
  background-color: white;
  min-width: 100%;
  padding: 16px;
}
h1 {
  font-family: IRANSans-bold;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  color: $dark-color;
  margin-bottom: 16px;
}
</style>
